import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormBuilder, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ResetPassword } from 'src/core/interfaces/resetPassword';

@Component({
  selector: 'vex-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit{

  form = this.fb.group({
    password: ['', [Validators.required]],
    confirmPassword: [''],
  }, { validators: this.checkPasswords });
  success = false;
  message = "";
  private email: string;
  private token: string;

  error = new BehaviorSubject<string>(null);
  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute
  ) { }

    ngOnInit(): void {
      this.route.queryParams.subscribe(params =>{
        if(!params.token){
          this.router.navigate(['/login']);
        }
        this.token = params.token;
        this.email = params.email;
      });
    }

  checkPasswords(group: AbstractControl):  ValidationErrors | null{ 
    let pass = group.get('password').value;
    let confirmPass = group.get('confirmPassword').value
    if(pass === confirmPass){
      return null
    } else {
      group.get('confirmPassword').setErrors({error: true});
      return {notSame: true};
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }


  send() {
    if (this.form.invalid) {
      return;
    }
    const password = this.form.value.password;
    const resetPasswordDto = new ResetPassword();
    resetPasswordDto.email = this.email;
    resetPasswordDto.token = this.token;
    resetPasswordDto.password = password;
    this.authService.resetPassword(resetPasswordDto).subscribe(
    {
        next: response => {
          if(response.status == 200){
            this.success = true;
            this.message = response.result;
          }
        },
        error: error => {
          this.error.next(error);
        }
    })
  }
}
